module.exports = __webpack_public_path__ + "static/img/pic03.e633d72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/images/pic03.jpg
// module id = IADR
// module chunks = 2